// extracted by mini-css-extract-plugin
export default {"overlay":"Mu-z","bodyOpen":"Nu-z","content":"Ou-z","header":"Pu-z","close":"Qu-z","closeNoHeading":"Ru-z"};